import { gql } from "@apollo/client";

export const APPROVE_GRADUATION_REQUESTS_MUTATION = gql`
  mutation ApproveGraduationRequests($input: BackofficeEducationApproveGraduationRequestsInput!) {
    approveGraduationRequests(input: $input) {
      success
      message
      graduationRequests {
        id
        graduationDate
        status
        submittedBy {
          id
          name
          email
        }
        processedBy {
          id
          name
          email
        }
        processedAt
        rejectionReason
      }
    }
  }
`;

export const REJECT_GRADUATION_REQUESTS_MUTATION = gql`
  mutation RejectGraduationRequests($input: BackofficeEducationRejectGraduationRequestsInput!) {
    rejectGraduationRequests(input: $input) {
      success
      message
      graduationRequests {
        id
        graduationDate
        status
        submittedBy {
          id
          name
          email
        }
        processedBy {
          id
          name
          email
        }
        processedAt
        rejectionReason
      }
    }
  }
`;
